module.exports = __webpack_public_path__ + "static/fujitsu-ce981153267ef662f1d7f3af8904bc60.jpg";